export default function validateUserBusinessNameInput(name: string): boolean {
  const expected = ['businessName', 'businessTaxId', 'businessNumber'];
  return expected.includes(name);
}
